// This optional code is used to register a service worker.
// register() is not called by default.

// This lets the app load faster on subsequent visits in production, and gives
// it offline capabilities. However, it also means that developers (and users)
// will only see deployed updates on subsequent visits to a page, after all the
// existing tabs open on the page have been closed, since previously cached
// resources are updated in the background.

// To learn more about the benefits of this model and instructions on how to
// opt-in, read https://cra.link/PWA

export async function register(config) {
  console.log("register");
  if ("serviceWorker" in navigator) {
    navigator.serviceWorker
      .register("./service-worker.js")
      .then((registration) => {
        console.log("Service worker registration succeeded:", registration);
      })
      .catch((err) => {
        console.log("Service worker registration failed:", err);
      });
  }
}

export function unregister() {
  console.log("unregister1");

  if ("serviceWorker" in navigator) {
    console.log("unregister2");
    navigator.serviceWorker.ready
      .then((registration) => {
        registration.unregister();
      })
      .catch((error) => {
        console.error(error.message);
      });
  }
}

let deferredPrompt;

window.addEventListener("beforeinstallprompt", function (event) {
  // Prevent Chrome 67 and earlier from automatically showing the prompt
  event.preventDefault();
  // Stash the event so it can be triggered later.
  deferredPrompt = event;
  console.log("not installed");
  const elem = document.querySelector(".disp");
  elem.style.display = "block";
});

// Installation must be done by a user gesture! Here, the button click
// hide our user interface that shows our A2HS button
export async function installPromt(e) {
  const { REACT_APP_URL } = process.env;
  console.log("installed");
  e?.preventDefault();
  console.log(deferredPrompt);
  // Show the prompt
  if (deferredPrompt) {
    console.log("not installed");
    deferredPrompt.prompt();
    // Wait for the user to respond to the prompt
    deferredPrompt.userChoice.then(async (choiceResult) => {
      if (choiceResult.outcome === "accepted") {
        console.log("User accepted the A2HS prompt");
        await fetch(`${REACT_APP_URL}/api/pwa`, { method: "POST" });

        const elem = document.querySelector(".disp");
        elem.style.display = "none";
      } else {
        console.log("User dismissed the A2HS prompt");
      }
      console.log("installed");
    });
  }
}

//
// export function pushNotify(){
//   if('serviceWorker' in navigator && 'PushManager' in window){
//
//     Notification.requestPermission().then(res=>{
//       console.log(res);
//     }).catch()
//
//   }
// }
